import "../../../assets/css/style.min.css"

import { closeModal_v2, form, g, log, openModal_v2, q, t } from "../../../../../utils";
import { initializeApp } from "firebase/app";
import { firebaseConfig } from "../../../components/config";
import { collection, doc, getDoc, getDocs, getFirestore, query, serverTimestamp, setDoc, where } from "firebase/firestore"
import { User } from "../../../components/user/index"
import { getFunctions, httpsCallable } from 'firebase/functions';

const dashboardApp = "delivery"

const firebaseApp = initializeApp(firebaseConfig);
const firestore = getFirestore()
const functions = getFunctions()

const user = new User(firebaseApp)

const getUser = httpsCallable(functions, "getUser")

export async function system(resource, callback) {
    const snapshot = await getDoc(doc(firestore, `system/${resource}`))
    if (snapshot.exists()) {
        callback(snapshot.data())
    }
}

const initUser = (user) => {
    const photoURL = user.photoURL;
    // The user's ID, unique to the Firebase project. Do NOT use
    // this value to authenticate with your backend server, if
    // you have one. Use User.getToken() instead.

    console.log(user);

    if (photoURL != undefined) {
        console.log(photoURL);
        g('profile_image').src = photoURL
    } else {
        g('profile_image').src = "https://firebasestorage.googleapis.com/v0/b/pickaapp-79307.appspot.com/o/Rectangle%201.png?alt=media&token=a63c9a1c-6e18-451c-9b3b-8c5e907d64be"
    }
}

user.init(async (u) => {
    const operator = await getDoc(doc(firestore, `dashboard/${u.uid}`))
    if (operator.exists()) {
        initUser(u)

        system("rideV2", (data) => {
            console.log(data);
            let mK;

            const localities = data.localities
            for (const key in localities) {
                if (Object.hasOwnProperty.call(localities, key)) {
                    const locality = localities[key];

                    g("repeater2").append(t(`<div class="js-repeater__item col-6">
                    <div class="switch-card bg radius-lg padding-md inner-glow border js-switch-card">
                        <div class="flex gap-xxs items-center  flex-wrap justify-between">
                            <h2 class="text-base">${key}</h2>

                            <button class="btn_edit" value="${key}">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <g id="Iconly/Light-Outline/Edit">
                                        <g id="Edit">
                                            <path id="Fill 1" fill-rule="evenodd" clip-rule="evenodd"
                                                d="M20.7508 21.9397H13.4978C13.0838 21.9397 12.7478 21.6037 12.7478 21.1897C12.7478 20.7757 13.0838 20.4397 13.4978 20.4397H20.7508C21.1648 20.4397 21.5008 20.7757 21.5008 21.1897C21.5008 21.6037 21.1648 21.9397 20.7508 21.9397Z"
                                                fill="black" />
                                            <g id="Group 5">
                                                <mask id="mask0_604_3512" style="mask-type:luminance"
                                                    maskUnits="userSpaceOnUse" x="2" y="3" width="18"
                                                    height="19">
                                                    <path id="Clip 4" fill-rule="evenodd"
                                                        clip-rule="evenodd"
                                                        d="M2.00031 3.00016H19.1809V21.9397H2.00031V3.00016Z"
                                                        fill="white" />
                                                </mask>
                                                <g mask="url(#mask0_604_3512)">
                                                    <path id="Fill 3" fill-rule="evenodd"
                                                        clip-rule="evenodd"
                                                        d="M13.1106 5.0168L3.69558 16.7918C3.52458 17.0058 3.46158 17.2818 3.52458 17.5468L4.20558 20.4318L7.24458 20.3938C7.53358 20.3908 7.80058 20.2618 7.97758 20.0418C11.1946 16.0168 17.3276 8.3428 17.5016 8.1178C17.6656 7.8518 17.7296 7.4758 17.6436 7.1138C17.5556 6.7428 17.3246 6.4278 16.9916 6.2268C16.9206 6.1778 15.2356 4.8698 15.1836 4.8288C14.5496 4.3208 13.6246 4.4088 13.1106 5.0168ZM3.61358 21.9398C3.26658 21.9398 2.96458 21.7018 2.88358 21.3628L2.06458 17.8918C1.89558 17.1728 2.06358 16.4308 2.52458 15.8548L11.9446 4.0728C11.9486 4.0688 11.9516 4.0638 11.9556 4.0598C12.9886 2.8248 14.8566 2.6428 16.1166 3.6538C16.1666 3.6928 17.8396 4.9928 17.8396 4.9928C18.4476 5.3548 18.9226 6.0018 19.1026 6.7678C19.2816 7.5258 19.1516 8.3078 18.7346 8.9688C18.7036 9.0178 18.6766 9.0598 9.14858 20.9798C8.68958 21.5518 8.00158 21.8848 7.26258 21.8938L3.62358 21.9398H3.61358Z"
                                                        fill="black" />
                                                </g>
                                            </g>
                                            <path id="Fill 6" fill-rule="evenodd" clip-rule="evenodd"
                                                d="M16.2234 11.6848C16.0634 11.6848 15.9034 11.6338 15.7664 11.5298L10.3144 7.34181C9.98636 7.08981 9.92436 6.61981 10.1764 6.28981C10.4294 5.96181 10.8994 5.90081 11.2284 6.15281L16.6814 10.3398C17.0094 10.5918 17.0714 11.0628 16.8184 11.3918C16.6714 11.5838 16.4484 11.6848 16.2234 11.6848Z"
                                                fill="black" />
                                        </g>
                                    </g>
                                </svg>
                            </button>
                        </div>

                        <div class="flex gap-xxs justify-between margin-top-md">
                            <dl class="dl-v2">
                                <div class="grid gap-xs">
                                    <div class="dl-v2__item border-left">
                                        <dt class="dl-v2__title">Base</dt>
                                        <dd class="dl-v2__description">${locality.base}</dd>
                                    </div>

                                    <div class="dl-v2__item border-left">
                                        <dt class="dl-v2__title">Charge Per Km</dt>
                                        <dd class="dl-v2__description">${locality.chargePerKm}</dd>
                                    </div>

                                    <div class="dl-v2__item border-left">
                                        <dt class="dl-v2__title">Charge Per Min</dt>
                                        <dd class="dl-v2__description">${locality.chargePerMin}</dd>
                                    </div>
                                    <div class="dl-v2__item border-left">
                                        <dt class="dl-v2__title">Charge Wait Per Min</dt>
                                        <dd class="dl-v2__description">${locality.chargeWait}</dd>
                                    </div>
                                    <div class="dl-v2__item border-left">
                                        <dt class="dl-v2__title">Commission</dt>
                                        <dd class="dl-v2__description">${locality.commission}%</dd>
                                    </div>
                                    <div class="dl-v2__item border-left">
                                        <dt class="dl-v2__title">Radius</dt>
                                        <dd class="dl-v2__description">${locality.radius}</dd>
                                    </div>
                                </div>
                            </dl>

                            <button>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <g id="Iconly/Light-Outline/Delete">
                                        <g id="Delete">
                                            <path id="Fill 1" fill-rule="evenodd" clip-rule="evenodd"
                                                d="M12.2466 22C10.8916 22 9.5706 21.985 8.2636 21.958C6.5916 21.925 5.4346 20.841 5.2456 19.129C4.9306 16.289 4.3916 9.595 4.3866 9.528C4.3526 9.115 4.6606 8.753 5.0736 8.72C5.4806 8.709 5.8486 8.995 5.8816 9.407C5.8866 9.475 6.4246 16.146 6.7366 18.964C6.8436 19.937 7.3686 20.439 8.2946 20.458C10.7946 20.511 13.3456 20.514 16.0956 20.464C17.0796 20.445 17.6116 19.953 17.7216 18.957C18.0316 16.163 18.5716 9.475 18.5776 9.407C18.6106 8.995 18.9756 8.707 19.3846 8.72C19.7976 8.754 20.1056 9.115 20.0726 9.528C20.0666 9.596 19.5246 16.307 19.2126 19.122C19.0186 20.869 17.8646 21.932 16.1226 21.964C14.7896 21.987 13.5036 22 12.2466 22Z"
                                                fill="black" />
                                            <path id="Fill 3" fill-rule="evenodd" clip-rule="evenodd"
                                                d="M20.708 6.9893H3.75C3.336 6.9893 3 6.6533 3 6.2393C3 5.8253 3.336 5.4893 3.75 5.4893H20.708C21.122 5.4893 21.458 5.8253 21.458 6.2393C21.458 6.6533 21.122 6.9893 20.708 6.9893Z"
                                                fill="black" />
                                            <path id="Fill 5" fill-rule="evenodd" clip-rule="evenodd"
                                                d="M17.4404 6.9893C16.3024 6.9893 15.3144 6.1783 15.0904 5.0623L14.8474 3.8463C14.7964 3.6613 14.5854 3.5003 14.3454 3.5003H10.1124C9.8724 3.5003 9.6614 3.6613 9.60039 3.8923L9.36739 5.0623C9.14439 6.1783 8.1554 6.9893 7.0174 6.9893C6.6034 6.9893 6.2674 6.6533 6.2674 6.2393C6.2674 5.8253 6.6034 5.4893 7.0174 5.4893C7.4434 5.4893 7.8134 5.1853 7.8974 4.7673L8.1404 3.5513C8.3874 2.6193 9.1944 2.0003 10.1124 2.0003H14.3454C15.2634 2.0003 16.0704 2.6193 16.3074 3.5063L16.5614 4.7673C16.6444 5.1853 17.0144 5.4893 17.4404 5.4893C17.8544 5.4893 18.1904 5.8253 18.1904 6.2393C18.1904 6.6533 17.8544 6.9893 17.4404 6.9893Z"
                                                fill="black" />
                                        </g>
                                    </g>
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>`))
                }
            }

            let oFormObject = document.forms["_option"]

            function mEdit(localityKey) {
                let locality = localities[localityKey]

                oFormObject.elements["base"].value = locality.base
                oFormObject.elements["chargePerKm"].value = locality.chargePerKm
                oFormObject.elements["chargePerMin"].value = locality.chargePerMin
                oFormObject.elements["chargeWait"].value = locality.chargeWait
                oFormObject.elements["commission"].value = locality.commission
                oFormObject.elements["radius"].value = locality.radius

                console.log(locality);

                openModal_v2("modal-form", () => {
                    alert("Updated successfuly!")
                    location.reload()
                })
            }

            form("_option", (data) => {
                localities[mK] = data
                console.log(localities);

                setDoc(doc(firestore, "system/rideV2"), {
                    localities: localities
                }, {
                    merge: true
                }).then(() => {
                    closeModal_v2("modal-form")
                }).catch((e) => {
                    alert(e.message)
                })
            })

            document.querySelectorAll(".btn_edit").forEach((localityBtn) => {
                localityBtn.addEventListener("click", () => {
                    mK = localityBtn.value
                    mEdit(mK)
                })
            })
        })



        // const operatorData = operator.data()

        // const appId = operatorData[dashboardApp].appId

        // get the app
        // const app = await getDoc(doc(firestore, `apps/${appId}`))
        // if (app.exists()) {
        // const appData = app.data()
        // const deliveryOptions = appData["options"]

        async function getRider(id, data) {
            const riderAc = await getDoc(doc(firestore, `user/${id}`))

            if (riderAc.exists()) {
                const riderAcData = riderAc.data()

                return t(`<tr class="tbl__row">
                        <td class="tbl__cell" role="cell">
                            <div class="flex items-center">
                                <figure
                                    class="width-lg height-lg radius-50% flex-shrink-0 overflow-hidden margin-right-xs">
                                    <img class="block width-100% height-100% object-cover" src="${riderAcData["profilePicture"]}" alt="Author picture">
                                </figure>

                                <div class="line-height-xs">
                                    <p class="margin-bottom-xxxxs"><a href="#0">${riderAcData.firstName} ${riderAcData.lastName}</a></p>
                                    <p class="color-contrast-medium"><a href="tel:${riderAcData["phoneNumber"]}">${riderAcData["phoneNumber"]}</a></p>
                                </div>
                            </div>
                        </td>

                        <td class="tbl__cell display@md" role="cell">---</td>

                        <td class="tbl__cell display@md" role="cell">${data.currentLocality}</td>

                        <td class="tbl__cell display@md" role="cell">
                            <span
                                class="inline-block text-sm bg-success bg-opacity-20% color-success-darker radius-full padding-y-xxxs padding-x-xs ws-nowrap">Online</span>
                        </td>

                        <td class="tbl__cell text-right display@md" role="cell">---</td>
                    </tr>`)
            } else {
                return t(`<duv/>`)
            }

        }

        let mT;
        let mO;

        // get riders
        // const qRiders = query(collection(firestore, "rider"), ...[where("owner", "==", u.uid)])
        // getDocs(qRiders).then((qs) => {
        //     qs.forEach(async (r) => {
        //         g("_riders").appendChild(await getRider(r.id, r.data()))
        //     })
        // }).catch((e) => alert(e.message))

        async function initForm(uid) {
            const acc = await getDoc(doc(firestore, `user/${uid}`))

            if (acc.exists()) {
                mT = uid

                const accData = acc.data()
                g("_n").innerText = `${accData.firstName} ${accData.lastName}`
            } else {
                alert("Account not found!")
            }
        }

        // g("_btn_look_up").addEventListener("click", () => {
        //     const phoneNumber = g("input-phone-x").value

        //     if (phoneNumber) {
        //         getUser({ phoneNumber: `+26${phoneNumber}` }).then((res) => {
        //             const resData = res.data

        //             if (resData.res == 1) {
        //                 initForm(resData.userData.uid)

        //                 openModal_v2("modal-form2")
        //             } else {
        //                 alert(resData.message)
        //             }
        //         }).catch((e) => {
        //             alert(e.message)
        //         })
        //     }
        // })

        form("_rider", (data) => {
            if (mT && data.plateNumber) {
                setDoc(doc(firestore, `rider/${mT}`), {
                    plateNumber: data.plateNumber,
                    isRegistered: true,
                    organization: u.uid,
                    timestamp: serverTimestamp()
                }).then(() => {
                    location.reload()
                }).catch((e) => {
                    alert(e.message)
                })
            } else {
                alert("Invalid data!")
            }
        })

        var repeater = document.getElementsByClassName('js-repeater');

        if (repeater.length > 0) {
            repeater[0].addEventListener('itemCloned', function (event) {
                openModal_v2("modal-form", () => {
                    location.reload()
                })
            });
        }

        let types;

        function checked(n) {
            // var c = ""

            // for (let k = 0; k < deliveryOptions.length; k++) {
            //     const element = deliveryOptions[k];

            //     if (element.name === n) {
            //         console.log(element);
            //         console.log(n);

            //         c = "checked"
            //     }
            // }

            // return c
        }

        await system("apps", (data) => {
            const delivery = data[dashboardApp]

            types = delivery["types"]



            for (let m = 0; m < types.length; m++) {
                const element = types[m];

                g("repeater").appendChild(t(`<div class="js-repeater__item col-6">
                        <div class="switch-card bg radius-lg padding-md inner-glow border js-switch-card">
                            <div class="flex flex-wrap gap-xxs items-center justify-between">
                                <figure class="switch-card__figure radius-50%">
                                    <img class="switch-card__img" src="${element.icon}" alt="App logo">
                                </figure>

                                <div class="switch js-switch-card__switch">
                                    <input class="switch__input" type="checkbox" name="${element.name}" id="option_${m}" value="${m}" ${checked(element.name)}>
                                    <label class="switch__label" for="option_${m}" aria-hidden="true">Activate app</label>
                                    <div class="switch__marker" aria-hidden="true"></div>
                                </div>
                            </div>

                            <div class="text-component margin-top-md">
                                <h2 class="text-base">${element.name}</h2>
                            </div>
                        </div>
                    </div>`))
            }

            document.querySelectorAll(".switch__input").forEach((swwitch) => {
                swwitch.addEventListener("click", () => {
                    if (swwitch.checked) {
                        mO = parseInt(swwitch.value)

                        openModal_v2("modal-form", () => {
                            location.reload()
                        })
                    }
                })
            })
        })

        require("../../../assets/js/scripts")
    } else {
        // subscribe
    }


}, () => { location.replace("../../../account/login") })
